import {pre_btn} from "@/config/config";

const TourModal = ({next, skip, pre, index, des, onEnd, className, wrapLintClassName, lineClassName}) =>{
  return <div className={`relative ${className}`}>
    <div className={`absolute top-[-100px] right-[2px] ${wrapLintClassName}`}>
      <PointLine className={`${lineClassName}`}></PointLine>
    </div>
    <div className={"min-w-[400px]"}>
      <div className={"mt-[40px] bg-[#fff] text-[14px]  min-h-[40px] text_222 p-[7px] rounded-lg"}>
        {
          des
        }
      </div>
      <div className={"flex w-full mt-[28px] items-center justify-between"}>
        <div>
          {
            skip && <div onClick={skip} className={"w-[86px] h-[28px] cursor-pointer flex items-center justify-center text-[#fff] border border-[#fff] rounded-full"}>Skip</div>
          }
        </div>
        <div className={"flex-1"}></div>
        <div className={"ml-auto flex w-full items-center justify-end"}>
          {
            pre && <img onClick={pre} className={"w-[28px] h-[28px] cursor-pointer mr-[16px]"} src={pre_btn} />
          }
          {
            onEnd ?
              <div onClick={onEnd} className={"bg-linear font-bold w-[112px] h-[36px] cursor-pointer flex items-center justify-center text-[#fff] rounded-full"}>Get it</div> :
              <div onClick={next} className={"bg-linear font-bold w-[112px] h-[36px] cursor-pointer flex items-center justify-center text-[#fff] rounded-full"}>Next({index}/3)</div>
          }
        </div>
      </div>
    </div>
  </div>;
};


const PointLine = ({ className }) =>{
  return <div className={`flex flex-col items-center ${className}`}>
    <div className={"rounded-full w-[8px] h-[7px] bg-linear"}></div>
    <div className={"h-[100px] w-[2px] bg-[#fff] rounded"}></div>
  </div>;
};


export default TourModal;
